/* eslint-disable @typescript-eslint/no-explicit-any */

import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../createStore'

export interface UserState {
  user: string
}

const initialState: UserState = {
  user: '',
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<any>) {
      state.user = action.payload
    },
  },
})
export const selectUser = (state: RootState) => state.user

export const { setUser } = userSlice.actions
export default userSlice.reducer
